import { render, staticRenderFns } from "./Educacional.vue?vue&type=template&id=0dcd819d&scoped=true"
import script from "./Educacional.vue?vue&type=script&lang=js"
export * from "./Educacional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcd819d",
  null
  
)

export default component.exports